import { render } from "./distpatchTable.vue?vue&type=template&id=492dc2c8&scoped=true"
import script from "./distpatchTable.vue?vue&type=script&lang=js"
export * from "./distpatchTable.vue?vue&type=script&lang=js"

import "./distpatchTable.vue?vue&type=style&index=0&id=492dc2c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492dc2c8"]])

export default __exports__